import type { BeaconRenderProps } from 'react-joyride';

export const CustomBeacon = (_props: BeaconRenderProps) => null;
